import { render, staticRenderFns } from "./partAndMeatSetting.vue?vue&type=template&id=af5e7f8c&scoped=true"
import script from "./partAndMeatSetting.vue?vue&type=script&lang=js"
export * from "./partAndMeatSetting.vue?vue&type=script&lang=js"
import style0 from "./partAndMeatSetting.vue?vue&type=style&index=0&id=af5e7f8c&prod&lang=less&scoped=true"
import style1 from "./partAndMeatSetting.vue?vue&type=style&index=1&id=af5e7f8c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5e7f8c",
  null
  
)

export default component.exports